var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._g(_vm._b({staticClass:"back-button",attrs:{"round":"","size":"mini"}},'el-button',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"back-button__icon"}),_vm._v(" 返回修改 ")])}
var staticRenderFns = []

export { render, staticRenderFns }